import { render, staticRenderFns } from "./ScientistDashboard.vue?vue&type=template&id=5686fc20&scoped=true&"
import script from "./ScientistDashboard.vue?vue&type=script&lang=js&"
export * from "./ScientistDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ScientistDashboard.vue?vue&type=style&index=0&id=5686fc20&lang=scss&scoped=true&"
import style1 from "./ScientistDashboard.vue?vue&type=style&index=1&id=5686fc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5686fc20",
  null
  
)

export default component.exports